import { inject } from '@angular/core';
import { Router, type CanActivateFn } from '@angular/router';
import { AuthenticationService } from '../services/authentication.service';
import { PermissionsService } from '../services/permession.service';
import { routes } from 'src/app/shared/common/routes.consatnt';

export const DashboardGuard: CanActivateFn = (route, state) => {
  const _router = inject(Router);
  const _authenticationService = inject(AuthenticationService);
  const _permissionsService = inject(PermissionsService);
  // Get the permissions from the route data
  const permissions = route.data['PermissionPageName'];

  // Check if the user has at least one of the permissions
  const hasAccess = permissions.some((permission: any) =>
    _authenticationService.checkAccess(permission),
  );

  if (hasAccess) {
    return true;
  } else {
    const list = routes;
    const firstAccessible =
      _permissionsService.getFirstAccessibleNavigation(list);
    _router.navigate([firstAccessible?.routeUrl]);
    return false;
  }
};
